<!-- <mat-toolbar id="toolbar" class="mat-elevation-z3" style="position:sticky;top:0px;z-index:2;background-color:#FFF;">
  <mat-toolbar-row>
    <ng-container *ngIf="authenticatedUser$ | async as authenticatedUser">
      <button style="height:36px;width:36px;" mat-icon-button>
        <sha-avatar [avatarUrl]="authenticatedUser.user.avatarUrl"
          [initials]="[authenticatedUser.user.firstName.charAt(0) + authenticatedUser.user.lastName.charAt(0)]">
        </sha-avatar>
      </button>
    </ng-container>
    <span fxFlex style="margin-left: 12px;">Maintenance Menu</span>
  </mat-toolbar-row>
</mat-toolbar> -->

<div *ngIf="$labourOpData | async as labourOpData" fxLayout="row" style="margin:16px;" fxLayoutAlign="center center">
  <div fxLayout="row" fxFlex class="content" fxLayoutAlign="space-around center">
    <div fxLayout="column" fxFlex="70" [@flyOutIn]="dank">
      <div fxLayout="row" fxFlexAlign="center" fxLayoutAlign="center center" class="mat-elevation-z1"
        style="width:80%;padding:16px;background-color:#FFF;border-radius:8px;"
        *ngIf="$vehicle | async as vehicle;else loadingVehicle">
        <div fxLayout="row" fxLayoutAlign="start center" style="width:100%;">
          <div style="height:36px;width:36px;border-radius:50%;background-color:#9E9E9E;color:#FFF;"
            fxLayoutAlign="center center">
            <mat-icon aria-label="Car icon">directions_car</mat-icon>
          </div>
          <div fxLayout="column" fxFlex fxLayoutAlign="center start" style="padding-left:16px;">
            <span class="mat-subheading-2" style="margin-bottom:0;">{{vehicle.year}} {{vehicle.make}}
              {{vehicle.model}}</span>
            <span class="mat-body-1 secondary-text">{{vehicle.currentMileage}}km</span>
          </div>
        </div>
      </div>

      <ng-template #loadingVehicle>
        <div fxLayout="column" fxFlexAlign="center" fxLayoutAlign="center center" class="mat-elevation-z1"
          style="width:80%;padding:16px;background-color:#FFF;border-radius:8px;">
          <div fxLayout="row" fxLayoutAlign="start center" style="width:100%;">
            <div style="height:36px;width:36px;border-radius:50%;background-color:#9E9E9E;color:#FFF;"
              fxLayoutAlign="center center">
              <mat-icon aria-label="Car icon">directions_car</mat-icon>
            </div>
            <div fxLayout="column" fxLayoutAlign="center start" fxFlex style="padding-left:16px;">
              <span class="animated-background"
                style="height:15px;width:80%;margin:6px 0 6px 0;border-radius:4px;"></span>
            </div>
          </div>
        </div>
      </ng-template>

      <div style="margin:24px 8px 0px 8px;" fxLayoutAlign="space-between center">
        <h2>Services</h2>
        <div fxLayout="start center">
          <span>Only Show Due</span>
          <mat-slide-toggle color="primary" [checked]="true" (change)=sliderChanged($event) style="margin-left:8px;">
          </mat-slide-toggle>
        </div>
      </div>

      <div style="margin:8px 8px 8px 8px;">
        <span class="mat-subheading-2" style="font-weight:500;">Factory Required Services</span>
      </div>

      <ng-container *ngIf="factoryRequiredServices; else loading">
        <div fxLayout="column"
          *ngFor="let menuItem of factoryRequiredServices | orderBy: ['frequencyMileage','dueDate','displayServiceGroup.name']"
          class="testing-concept" class="mat-elevation-z1"
          style="overflow:hidden;page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div fxLayout="column">
              <h3 class="mat-body-2">{{menuItem.displayServiceGroup.name}}</h3>
              <h4 class="mat-body-1 secondary-text">Due {{menuItem.dueDate| date}} {{menuItem.dueBy}}
                ({{menuItem.frequencyMileage}}km or {{menuItem.frequencyMonths}} months) </h4>

            </div>
            <div *ngIf="labourOpData?.serviceGroupRates; else loadPricing">
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag !== 'M'">
                {{getPrice(menuItem.displayServiceGroup,
                labourOpData.serviceGroupRates) | currency}}</h3>
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag === 'M'">N/A</h3>
            </div>
            <ng-template #loadPricing>
              <h3 class="animated-background" style="height:20px;width:26px;margin:5px 0 5px 0;border-radius:4px;"></h3>
            </ng-template>
          </div>
          <ul *ngIf="labourOpData?.services;else loadingServices">
            <li *ngFor="let service of menuItem.displayServiceGroup.services" [@fadeInOut]
              class="mat-body-1 secondary-text">{{labourOpData.services[service].name}}</li>
          </ul>
          <ng-template #loadingServices>
            <ul>
              <li class="animated-background secondary-text"
                style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
              <li class="animated-background secondary-text"
                style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
            </ul>
          </ng-template>
          <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <button mat-icon-button [disabled]="menuItem.serviceGroup.useFlag !== 'M'"
                (click)="selectService(menuItem, labourOpData.serviceGroups, labourOpData.serviceGroupRates)">
                <mat-icon>view_list</mat-icon>
              </button>
              <button mat-icon-button [disabled]="menuItem.displayServiceGroup.salesHint == null"
                (click)="viewSalesHint(menuItem.displayServiceGroup.salesHint)">
                <mat-icon>help</mat-icon>
              </button>
            </div>

            <div>
              <div fxLayout="row">
                <ng-container>
                  <div>
                    <button mat-icon-button (click)="selectDeclinedReason(menuItem, declinedReasons)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </div>
                </ng-container>

                <ng-container>
                  <div>
                    <button *ngIf="authenticatedUser$ | async as authenticatedUser" mat-icon-button
                      (click)="acceptService(menuItem.displayServiceGroup, labourOpData, authenticatedUser.user.xselleratorEmployeeId)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>check</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>


      <div style="margin:24px 16px 8px 8px;">
        <span class="mat-subheading-2" style="font-weight:500;">Factory Recommended Services</span>
      </div>

      <ng-container *ngIf="factoryRecommendedServices; else loading">
        <div fxLayout="column"
          *ngFor="let menuItem of factoryRecommendedServices | orderBy: ['frequencyMileage','dueDate','displayServiceGroup.name']"
          class="testing-concept" class="mat-elevation-z1"
          style="overflow:hidden;page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div fxLayout="column">
              <h3 class="mat-body-2">{{menuItem.displayServiceGroup.name}}</h3>
              <h4 class="mat-body-1 secondary-text">Due {{menuItem.dueDate| date}} {{menuItem.dueBy}}
                ({{menuItem.frequencyMileage}}km or {{menuItem.frequencyMonths}} months) </h4>

            </div>
            <div *ngIf="labourOpData?.serviceGroupRates; else loadPricing">
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag !== 'M'">
                {{getPrice(menuItem.displayServiceGroup,
                labourOpData.serviceGroupRates) | currency}}</h3>
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag === 'M'">N/A</h3>
            </div>
            <ng-template #loadPricing>
              <h3 class="animated-background" style="height:20px;width:26px;margin:5px 0 5px 0;border-radius:4px;"></h3>
            </ng-template>
          </div>
          <ul *ngIf="labourOpData?.services;else loadingServices">
            <li *ngFor="let service of menuItem.displayServiceGroup.services" [@fadeInOut]
              class="mat-body-1 secondary-text">{{labourOpData.services[service].name}}</li>
          </ul>
          <ng-template #loadingServices>
            <ul>
              <li class="animated-background secondary-text"
                style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
              <li class="animated-background secondary-text"
                style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
            </ul>
          </ng-template>
          <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <button mat-icon-button [disabled]="menuItem.serviceGroup.useFlag !== 'M'"
                (click)="selectService(menuItem, labourOpData.serviceGroups, labourOpData.serviceGroupRates)">
                <mat-icon>view_list</mat-icon>
              </button>
              <button mat-icon-button [disabled]="menuItem.displayServiceGroup.salesHint == null"
                (click)="viewSalesHint(menuItem.displayServiceGroup.salesHint)">
                <mat-icon>help</mat-icon>
              </button>
            </div>

            <div>
              <div fxLayout="row">
                <ng-container>
                  <div>
                    <button mat-icon-button (click)="selectDeclinedReason(menuItem, declinedReasons)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </div>
                </ng-container>

                <ng-container>
                  <div>
                    <button *ngIf="authenticatedUser$ | async as authenticatedUser" mat-icon-button
                      (click)="acceptService(menuItem.displayServiceGroup, labourOpData, authenticatedUser.user.xselleratorEmployeeId)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>check</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div style="margin:24px 16px 8px 8px;">
        <span class="mat-subheading-2" style="font-weight:500;">Dealer Recommended Services</span>
      </div>

      <ng-container *ngIf="dealerRecommendedServices; else loading">
        <div fxLayout="column"
          *ngFor="let menuItem of dealerRecommendedServices | orderBy: ['frequencyMileage','dueDate','displayServiceGroup.name']"
          class="testing-concept" class="mat-elevation-z1"
          style="overflow:hidden;page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div fxLayout="column">
              <h3 class="mat-body-2">{{menuItem.displayServiceGroup.name}}</h3>
              <h4 class="mat-body-1 secondary-text">Due {{menuItem.dueDate| date}} {{menuItem.dueBy}}
                ({{menuItem.frequencyMileage}}km or {{menuItem.frequencyMonths}} months) </h4>

            </div>
            <div *ngIf="labourOpData?.serviceGroupRates; else loadPricing">
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag !== 'M'">
                {{getPrice(menuItem.displayServiceGroup,
                labourOpData.serviceGroupRates) | currency}}</h3>
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag === 'M'">N/A</h3>
            </div>
            <ng-template #loadPricing>
              <h3 class="animated-background" style="height:20px;width:26px;margin:5px 0 5px 0;border-radius:4px;"></h3>
            </ng-template>
          </div>
          <ul *ngIf="labourOpData?.services;else loadingServices">
            <li *ngFor="let service of menuItem.displayServiceGroup.services" [@fadeInOut]
              class="mat-body-1 secondary-text">{{labourOpData.services[service].name}}</li>
          </ul>
          <ng-template #loadingServices>
            <ul>
              <li class="animated-background secondary-text"
                style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
              <li class="animated-background secondary-text"
                style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
            </ul>
          </ng-template>
          <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <button mat-icon-button [disabled]="menuItem.serviceGroup.useFlag !== 'M'"
                (click)="selectService(menuItem, labourOpData.serviceGroups, labourOpData.serviceGroupRates)">
                <mat-icon>view_list</mat-icon>
              </button>
              <button mat-icon-button [disabled]="menuItem.displayServiceGroup.salesHint == null"
                (click)="viewSalesHint(menuItem.displayServiceGroup.salesHint)">
                <mat-icon>help</mat-icon>
              </button>
            </div>

            <div>
              <div fxLayout="row">
                <ng-container>
                  <div>
                    <button mat-icon-button (click)="selectDeclinedReason(menuItem, declinedReasons)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </div>
                </ng-container>

                <ng-container>
                  <div>
                    <button *ngIf="authenticatedUser$ | async as authenticatedUser" mat-icon-button
                      (click)="acceptService(menuItem.displayServiceGroup, labourOpData, authenticatedUser.user.xselleratorEmployeeId)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>check</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>



      <ng-template #loading>
        <div class="mat-elevation-z1"
          style="page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;"
          *ngFor="let placeholder of [1,2,3,4]">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <h3 class="animated-background" style="height:20px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></h3>
            <h3 class="animated-background" style="height:18px;width:26px;margin:5px 0 5px 0;border-radius:4px;"></h3>
          </div>
          <h3 class="animated-background" style="height:20px;width:30%;margin:5px 0 5px 0;border-radius:4px;"></h3>
          <ul style="margin:20px 0 12px 0;">
            <li class="animated-background secondary-text"
              style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
            <li class="animated-background secondary-text"
              style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
          </ul>
          <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <button mat-icon-button [disabled]="true">
                <mat-icon>view_list</mat-icon>
              </button>
              <button mat-icon-button [disabled]="true">
                <mat-icon>history</mat-icon>
              </button>
            </div>
            <div>
              <button mat-icon-button [disabled]="true">
                <mat-icon>clear</mat-icon>
              </button>

              <button mat-icon-button [disabled]="true">
                <mat-icon>check</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

  </div>
</div>